function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { LoginForm } from 'swag-client-common/components/login-form';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import classes from './login-popup.scss';
const LoginPopup = _ref => {
  let {
      isOpen,
      onClose
    } = _ref,
    params = _objectWithoutProperties(_ref, ["isOpen", "onClose"]);
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    onRequestClose: onClose,
    content: /*#__PURE__*/React.createElement(LoginForm, params),
    dialogClass: classes.popup,
    bodyClassName: classes.bodyClassName,
    contentClassName: classes.contentClassName,
    actionsContainerClassName: classes.actionsContainerClassName,
    paperClassName: classes.paperClassName,
    closeButtonClassName: params.isLimitedEdition ? classes.orangeClose : '',
    dataPopup: "Login"
  });
};
export { LoginPopup };